import React, { Component } from 'react'
import { Card, Button, Row, Col, Input, Label, CardBody } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { dataCoberturas } from 'redux/selectors/sPymes'
import Select1 from 'react-select';
import NumberFormat from 'react-number-format';

class CoberturaGeneralPymes extends Component {
    constructor(props) {
        super(props)
        const generales = {
            numPersonas: 0,
            sumaAsegurada: 0,
            gastosMedicos: 0,
            gastosSepelio: 0,
            gastosAmbulancia: 0
        }
        this.state = { guardar: false, generales, estadoGenerales: false, cobGenerales: [], cambiaData: 'btn btn-primary' }
        console.log('CONSTRUCTOR')
    }
    handleClick = async (datos, i, siguiente) => {
        const { idCobertura } = this.props
        let { guardar, generales } = this.state

        //item = item.find(item => item.codigo === 'roturaDeVidrios')
        console.log('RESPUESTA', idCobertura, generales, '------------------------------------------')
        const res = await this.props.guardarCobertura({ arrayData: [], idCobertura, generales })
        console.log('RESPUESTA', res)

        let ubicaciones = []
        let { cobGenerales } = this.state

        if (res.transaccion) {
            ubicaciones = res.ubicaciones
            generales = res.generales
            //cobGenerales = res.limites
            guardar = true
        } else {
            guardar = this.state.guardar
        }

        this.setState({ guardar, generales, cobGenerales, cambiaData: 'btn btn-primary' })

        if (!guardar) window.scroll(0, 0)
    }
    componentDidMount() {
        const { cobGenerales } = this.props
        let generales = cobGenerales.reduce((i, { codigo }) => ({ ...i, [codigo]: 0 }), {})
        this.setState({ cobGenerales, generales })
    }
    handleBack = () => {
        this.props.handleAtras()
    }

    handleGenerales = (valor, codigo, maximo, generales) => {

        const { titulo, nombreGiro, idCobertura } = this.props




        if (Array.isArray(maximo)) {
            generales = { ...generales, [codigo]: valor }
            this.setState({ generales, cambiaData: 'btn btn-purple fe-pulse' })

            if (codigo == 'opcion' && idCobertura == 'transporteInterno') {
                switch (valor) {
                    case 'nueva':
                        generales = { ...generales, 'transporteInternoEstimadoLAP': 0 }
                        this.setState({ generales, cambiaData: 'btn btn-purple fe-pulse' })
                        break;
                    case 'usada':
                        generales = { ...generales, 'transporteInternoEstimadoTodoRiesgo': 0 }
                        this.setState({ generales, cambiaData: 'btn btn-purple fe-pulse' })
                        break;
                    case 'ambos':
                        break;
                    default:
                        break;
                }
            }
        } else {
            valor = parseFloat(valor)
            if (isNaN(valor)) valor = 0
            if (valor >= 0) {
                maximo = parseFloat(maximo)
                if (valor <= maximo || maximo == -1) {
                    generales = { ...generales, [codigo]: valor }
                    this.setState({ generales, cambiaData: 'btn btn-purple fe-pulse' })
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { cobGenerales } = this.props
        if (cobGenerales !== prevProps.cobGenerales) this.setState({ cobGenerales })

    }

    render() {

        const { generales, cobGenerales, cambiaData } = this.state
        const { titulo, nombreGiro, idCobertura } = this.props

        return (
            <>
                {cobGenerales && cobGenerales.length === 0 ?


                    <Col md={12} >
                        <Card key={'ubicacionesCobertura0'} >
                            <CardBody >
                                <Row className="mb-5 ">

                                    <Col md={12} > <p style={{ display: 'block', margin: 'auto' }}>No se puede realizar esta cobertura, continue con la siguiente </p></Col>

                                </Row>
                            </CardBody>
                        </Card>
                    </Col> :
                    <Col md={12}>



                        <div className='row card'>
                            <Col md={12} className='card-body' style={{ background: '#fff', }}>
                                <div className='flex' style={{ justifyContent: 'space-between', }}>
                                    <label style={{ fontWeight: 700, }}> Coberturas Generales: </label>
                                    <label style={{ color: '#909090', }}>Valor Máximo</label>
                                </div>
                                {cobGenerales && cobGenerales.map(({ codigo, descripcion, valor }, i) =>
                                    !Array.isArray(valor) ?


                                        <Row key={'coberGenerales' + i + codigo}>
                                            <Col xs={6} sm={4} > <p>{descripcion}</p> </Col>
                                            <Col xs={6} sm={5}>

                                                <NumberFormat
                                                    className="form-control"
                                                    disabled={idCobertura == 'transporteInterno'
                                                        && ((codigo == 'transporteInternoEstimadoTodoRiesgo' &&
                                                            (!generales.opcion || generales.opcion == 'usada')) ||
                                                            codigo == 'transporteInternoEstimadoLAP' && (!generales.opcion ||
                                                                generales.opcion == 'nueva'))}
                                                    style={{ width: 'inherit', fontSize: 20, textAlign: 'right', }}
                                                    value={generales[codigo] ? generales[codigo] : 0}
                                                    thousandSeparator={','}
                                                    decimalSeparator={'.'}
                                                    decimalScale={2}
                                                    prefix={''}
                                                    onValueChange={(_valor, e) => {

                                                        this.handleGenerales(_valor.floatValue, codigo, valor,generales)
                                                    }}

                                                />
                                            </Col>
                                            <Col sm={3}> <p style={{ textAlign: 'right', color: '#909090', }}>{valor != -1 ? valor.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : null}</p> </Col>
                                        </Row>

                                        :

                                        <Row key={'coberGenerales' + i + codigo}>
                                            <Col xs={6} sm={4} > <p>{descripcion}</p> </Col>
                                            <Col xs={6} sm={5}>
                                                <Select1
                                                    options={listSlct1(valor)}
                                                    placeholder={'Seleccione una opción'}


                                                    onChange={
                                                        (value, e) => {
                                                            this.handleGenerales(value.value, codigo, valor, generales)
                                                        }
                                                    }

                                                    validationOption={{
                                                        name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                        msgOnError:
                                                            "Por favor seleccione " + descripcion,
                                                    }}
                                                />

                                                {idCobertura == 'transporteInterno' && codigo == 'riesgo' ?
                                                    <h5>En caso de que la mercadería transportada no se encuentre detallada en el listado, por favor contactarse su ejecutivo de AIG</h5>

                                                    : null}


                                            </Col>

                                            <Col sm={3}> <p style={{ textAlign: 'right', color: '#909090', }}></p> </Col>
                                        </Row>
                                )}
                            </Col>
                            <div className='flex' style={{ margin: 10, }}  >
                                <Button className="btn btn-detail-gray" onClick={() => this.handleBack()} style={{ margin: "auto" }} >
                                    <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"  REGRESAR"}
                                </Button>
                                <Button className={cambiaData} onClick={() => { /*setValidate(true);*/ this.handleClick([], 0, false) }} style={{ margin: "auto", }} >
                                    <i className="fa fa-chevron-circle-right " aria-hidden="true" />{' ACTUALIZAR VALORES'}
                                </Button>
                            </div>
                        </div>


                    </Col >}
            </>

        )
    }
}

const listSlct1 = (list) => {
    const formatList = []
    for (const idx in list) {

        formatList.push({
            value: list[idx]['claveOpcion'] || list[idx]['nivelRiesgo'],
            label: list[idx]['textoOpcion'] || list[idx]['tipoRiesgo']
        })
    }


    // return
    return formatList
}
const mapStateToProps = (state, props) => ({
    //coberturas: state.dataPymes.maxCoberturas,
    cobGenerales: state.dataPymes.coberturasGenerales[props.idCobertura],
    data: dataCoberturas(state, props),
    cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore,
})

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        null
    )(CoberturaGeneralPymes)
);